module.exports = __webpack_public_path__ + "img/location-3-upcoming.b71f6532.png";